import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import styled from 'styled-components';
import { useFetchKnowledgeBase } from '../../knowledge-base/queries/KnowledgeBasesQuery';
import { useCurrentKnowledgeBaseId } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHistory } from 'react-router-dom';
import KnowledgeBaseMigrationSelect from '../../knowledge-base/components/KnowledgeBaseMigrationSelect';
import { getKnowledgeBaseOnboardingPath } from '../../routing/utils/internalPaths';
import { Flex } from 'foundations-components/components/Flex';
import { useCallback } from 'react';
import { SuccessIcon, LinkIcon, KnowledgeBaseIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const URLContainer = styled.div.withConfig({
  displayName: "KnowledgeBaseSelectWrapper__URLContainer",
  componentId: "jp5c7y-0"
})(["display:inline-block;"]);
const KnowledgeBaseSelectContainer = styled.div.withConfig({
  displayName: "KnowledgeBaseSelectWrapper__KnowledgeBaseSelectContainer",
  componentId: "jp5c7y-1"
})(["&:has(+ div){border-right:1px solid ", ";margin-right:12px;padding-right:12px;}"], ({
  theme
}) => theme.color['border-core-default']);
const selectLabel = /*#__PURE__*/_jsxs("span", {
  children: [/*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineEnd: "200",
    children: /*#__PURE__*/_jsx(KnowledgeBaseIcon, {})
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.knowledgeBaseSelect.label"
  })]
});
const KnowledgeBaseSelectWrapper = props => {
  const currentKnowledgeBaseId = useCurrentKnowledgeBaseId();
  const {
    data: knowledgeBase
  } = useFetchKnowledgeBase(currentKnowledgeBaseId);
  const selectedKnowledgeBaseUrl = knowledgeBase && knowledgeBase.absoluteUrl;
  const history = useHistory();
  const SingleSelectOptionWithCheckmark = useCallback(_ref => {
    let {
        children,
        option
      } = _ref,
      optionsProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center"
    }, optionsProps, {
      children: [currentKnowledgeBaseId === option.value ? /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        paddingInlineStart: "400",
        children: /*#__PURE__*/_jsx(SuccessIcon, {
          color: 'fill-positive-default',
          size: "300"
        })
      }) : undefined, children]
    }));
  }, [currentKnowledgeBaseId]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: "200",
    children: [/*#__PURE__*/_jsxs(KnowledgeBaseSelectContainer, {
      children: [selectLabel ? /*#__PURE__*/_jsx(Box, {
        display: "inline-flex",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: selectLabel
        })
      }) : undefined, /*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        color: "text-interactive-default",
        display: "inline-block",
        children: /*#__PURE__*/_jsx(KnowledgeBaseMigrationSelect, Object.assign({
          "data-test-id": "knowledge-base-switcher",
          buttonUse: "link",
          onAddKnowledgeBaseClick: () => history.push(`${getKnowledgeBaseOnboardingPath()}?cancel=back`),
          selectedKnowledgeBaseId: currentKnowledgeBaseId,
          optionComponent: SingleSelectOptionWithCheckmark
        }, props))
      })]
    }), selectedKnowledgeBaseUrl !== undefined ? /*#__PURE__*/_jsxs(URLContainer, {
      children: [/*#__PURE__*/_jsxs(Box, {
        display: "inline-flex",
        marginInlineEnd: "200",
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          display: "inline-flex",
          gap: "100",
          children: /*#__PURE__*/_jsx(LinkIcon, {})
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "content-management-listing-lib.components.ContentGroupSelect.urlLabel"
          })
        })]
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: selectedKnowledgeBaseUrl,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          color: "text-interactive-default",
          display: "inline-block",
          textDecoration: "underline",
          children: selectedKnowledgeBaseUrl
        })
      })]
    }) : undefined]
  });
};
export default KnowledgeBaseSelectWrapper;